import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IssuesModel from '../models/IssuesModel'
import MapLayerSwitcher from './MapLayerSwitcher'
import { Row, Col, Input, Button, Icon, Alert, Modal  } from 'antd'
import legenda_ai from '../assets/images/legenda-ai.png'
const { TextArea } = Input

class SimpleIssueStep2 extends Component {

    constructor(props) {
        super(props)
        this.onChangeAddress = this.onChangeAddress.bind(this)
        this.putMapMarker = this.putMapMarker.bind(this)
        this.onGetDeviceGeolocation = this.onGetDeviceGeolocation.bind(this)
        this.renderMap = this.renderMap.bind(this)
        this.mapMarker = false
        this.mapSelectDrag = false

        this.state = {
            legenda_modal: false,
            legenda_img: legenda_ai
        }
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const map = this.props.map
        IssuesModel.olMap = map
        map.setTarget(mapTarget)
        map.getView().setZoom(this.props.mapZoom)
        map.getView().setCenter(this.props.mapCenter)
    }

    componentWillReceiveProps(nextProps) {
        const map = this.props.map
        map.getView().setZoom(nextProps.mapZoom)
        map.getView().setCenter(nextProps.mapCenter)
        if (nextProps.id || nextProps.putMarker) this.putMapMarker(nextProps.mapCenter)
        if (nextProps.className === 'visible') {
            this.renderMap()
        }
    }

    showLegendModal = (legenda_img) => {
        this.setState({
            legenda_modal: true,
            legenda_img: legenda_img,
        });
    }

    hideLegendModal = (e) => {
        this.setState({
          legenda_modal: false
        });
      }

    // Put map marker
    putMapMarker(coords) {
        this.mapMarker = IssuesModel.putMarker(coords, true)

        // Add select and drag interaction
        if (!this.mapSelectDrag) {
            this.mapSelectDrag = IssuesModel.addMapSelectAndDrag((coords) => {
                this.props.changeMapCenter(coords.native, this.props.map.getView().getZoom(), true)
            })

            // Add marker to select control
            this.mapSelectDrag.getFeatures().push(this.mapMarker)
            this.props.changeMapCenter(coords, this.props.map.getView().getZoom(), true)
        }
    }

    renderMap() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        const updateMap = setInterval(() => {
            if (mapTarget.offsetHeight) {
                this.props.map.updateSize()
                return clearInterval(updateMap)
            }
        }, 50)
    }

    onChangeAddress(address) {
        this.props.gmapsGeocoder(address)
    }

    onGetDeviceGeolocation() {
        this.props.getDeviceGeolocation()
    }

    componentWillUnmount() {
        this.props.map.setTarget(null)
    }

    noAccents(s) {
        var r = s.toLowerCase();
        r = r.replace(new RegExp("\\s", 'g'),"");
        r = r.replace(new RegExp("[àáâãäå]", 'g'),"a")
        r = r.replace(new RegExp("æ", 'g'),"ae")
        r = r.replace(new RegExp("ç", 'g'),"c")
        r = r.replace(new RegExp("[èéêë]", 'g'),"e")
        r = r.replace(new RegExp("[ìíîï]", 'g'),"i")
        r = r.replace(new RegExp("ñ", 'g'),"n")
        r = r.replace(new RegExp("[òóôõö]", 'g'),"o")
        r = r.replace(new RegExp("œ", 'g'),"oe")
        r = r.replace(new RegExp("[ùúûü]", 'g'),"u")
        r = r.replace(new RegExp("[ýÿ]", 'g'),"y")
        r = r.replace(new RegExp("\\W", 'g'),"")
        return r
    }

    render() {
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Localização</legend></Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="address" className="ant-form-item-required" title="Localizar por endereço">Localização</label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Input ref="address"
                            value={this.props.address}
                            onChange={(e) => this.props.onChangeField('address', e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' ? this.onChangeAddress(this.props.address) : false }
                            suffix={(<Button type="primary" onClick={(e) => this.onChangeAddress(this.props.address) }>
                                <span className="hide-small">Centrar no Mapa</span>
                                <span className="hide-medium">
                                    <Icon type="environment" />
                                </span>
                            </Button>)}
                        />
                        <div className="map" id="map" ref="map" style={{height: '252px', marginTop: '24px'}}>
                            <div id="putMapMarker">
                                <Button type="primary" icon="pushpin"
                                    title="Definir localização geográfica"
                                    onClick={(e) => this.putMapMarker(this.props.mapCenter)}
                                />
                            </div>
                            <div id="deviceGeo">
                                <Button type="primary" icon="global"
                                    title="Obter coordenadas do dispositivo"
                                    onClick={(e) => this.onGetDeviceGeolocation()}
                                />
                            </div>
                            <MapLayerSwitcher map={this.props.map} />
                        </div>
                        { this.props.v.show && this.props.v.freguesia.msg && !this.props.freguesia ? (
                            <Alert message={this.props.v.freguesia.msg} type="error" showIcon />
                        ) : '' }
                    </div>
                </div>

                <div className="ant-row ant-form-item" style={{marginBottom: '0', display: this.props.freguesia ? 'none' : 'block' }}>
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6"></div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <label className="ant-form-item-required location-warning blink-me" title="Localização obrigatória">
                            Coloque o marcador no mapa clicando <a role="button" title="Definir localização geográfica"
                                onClick={(e) => this.putMapMarker(this.props.mapCenter)}
                            >aqui</a> e arraste para a zona litoral
                        </label>
                    </div>
                </div>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="email" className="ant-form-item" title="Endereço de E-mail">
                            Endereço de E-mail
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Input id="email"
                            value={this.props.email}
                            onChange={(e) => this.props.onChangeField('email', e.target.value)}
                        />
                    </div>
                </div>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="description" className="ant-form-item-required" title="Observações da Ocorrência">Observações</label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <div className="ant-form-item-control ">
                            <TextArea id="description" rows={6} value={this.props.obs}
                                onChange={(e) => this.props.onChangeField('obs', e.target.value)} />
                        </div>
                    </div>
                </div>

                <Modal
                    visible={this.state.legenda_modal}
                    title="Legenda"
                    wrapClassName="vertical-center-modal"
                    onCancel={this.hideLegendModal}
                    footer={[]}
                    >
                        <div style={{textAlign: 'center'}}>
                            <img src={this.state.legenda_img} alt="" title="" style={{width: '100%'}} />
                        </div>
                    </Modal>

            </div>
        )
    }
}

export default SimpleIssueStep2;



// WEBPACK FOOTER //
// ./src/components/SimpleIssueStep2.js